export const environment = {
  production: false,
  apiUrl: 'https://api-dev.rezevent.io',
};
